export default "__VITE_ASSET__589aa880__"